import { motion } from "framer-motion";
import styled from "styled-components";
import { StyledComponentsThemWrapper } from "../../StyledComponentsThemWrapper";

const MAX_VISIBLE = 7;

const DotContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  padding: 4px 0;
  gap: 6px;
`;

const Dot = styled(motion.button)`
  width: ${(p) => (p.isActive ? '20px' : '8px')};
  height: 8px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  outline: none;
  padding: 0;
  background-color: ${(p) =>
    p.isActive ? p.theme.palette.v2.primary : '#d4d4d4'};
  opacity: ${(p) => (p.isActive ? 1 : 0.6)};
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:focus-visible {
    box-shadow: 0 0 0 2px ${(p) => p.theme.palette.primary.main};
  }
`;

const Counter = styled.span`
  font-size: 0.68rem;
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.2px;
  white-space: nowrap;
`;

const NavigationDots = ({ count, activeIndex, onDotClick }) => {
  if (count <= 1) return null;

  if (count > MAX_VISIBLE) {
    return (
      <StyledComponentsThemWrapper>
        <DotContainer>
          <Counter>{activeIndex + 1} / {count}</Counter>
        </DotContainer>
      </StyledComponentsThemWrapper>
    );
  }

  return (
    <StyledComponentsThemWrapper>
      <DotContainer>
        {[...Array(count)].map((_, i) => (
          <Dot
            key={i}
            isActive={activeIndex === i}
            onClick={() => onDotClick(i)}
            whileHover={{ scale: 1.15 }}
            whileTap={{ scale: 0.9 }}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </DotContainer>
    </StyledComponentsThemWrapper>
  );
};

export default NavigationDots;
